import {
  MaterialSymbol,
  Facebook,
  Instagram,
  Twitter,
} from '@florencelabs/icons';
import clsx from 'clsx';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { lato } from '@provider-directory/app/ui/fonts';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { WPLinkedIn, WPPinterest } from './whiteplains-icons';
import { BASE_URL, WPBaseLink } from './whiteplains-utils';

import './whiteplains-footer.css';

const backgroundURL =
  'https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1900/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg';

export const WhiteplainsFooter = (): ReactElement => {
  const year = new Date().getFullYear();
  const analytics = useAnalytics();
  const { t } = useTranslation();

  return (
    <footer
      className={clsx(lato.className, 'c-footer-primary')}
      aria-labelledby={'wp-footer-heading'}
    >
      <h2 id={'wp-footer-heading'} className={'sr-only'}>
        {t('footer.title')}
      </h2>
      <div className={'c-footer-primary__top'}>
        <div className={'c-footer-enews'}>
          <div
            className={'c-footer-enews__text o-scroll-fade is-visible'}
            data-trigger={''}
          >
            <h3 className={'h3'}>Subscribe to our e-newsletter</h3>
            <p className={'p'}>
              Sign up to receive our e-newsletter for the latest health and
              wellness information from White Plains Hospital.
            </p>
            <a
              href={'https://healthmatters.wphospital.org/#nf-form-2-cont'}
              target={'_blank'}
              className={'btn btn-primary btn-rev'}
              rel={'noopener noreferrer'}
              onClick={() => {
                analytics.navigationClickEvent({
                  navigationType: 'footer',
                  clickText: 'Subscribe to our e-newsletter',
                  linkType: 'link',
                });
              }}
            >
              Visit Health Matters to sign up{' '}
              <MaterialSymbol
                aria-hidden={'true'}
                name={'arrow_forward'}
                className={'fa fa-arrow-right'}
              />
            </a>
          </div>
          <div
            className={'c-footer-enews__image lazyloaded fade-in'}
            data-bgset={
              'https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_480/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 480w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_640/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 640w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_800/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 800w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1500/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 1500w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1900/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 1900w'
            }
            data-bgsizes={'auto'}
            style={{
              backgroundPosition: '50% 50%',
              background: `url(${backgroundURL})`,
            }}
          >
            <picture style={{ display: 'none' }}>
              <source
                data-srcset={
                  'https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_480/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 480w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_640/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 640w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_800/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 800w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1500/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 1500w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1900/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 1900w'
                }
                sizes={'1589px'}
                srcSet={
                  'https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_480/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 480w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_640/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 640w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_800/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 800w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1500/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 1500w,https://res.cloudinary.com/dpmykpsih/image/upload/c_fill,f_auto,q_auto,w_1900/white-plains-site-400/media/6ac8320a98c0487c99bde93f127dc498/enewsimage.jpg 1900w'
                }
              />
              <img
                alt={''}
                className={'lazyautosizes lazyloaded ls-is-cached'}
                data-sizes={'auto'}
                data-parent-fit={'cover'}
                sizes={'1589px'}
              />
            </picture>
          </div>
        </div>
      </div>
      <div
        className={'c-footer-primary__bottom o-scroll-fade is-visible'}
        data-trigger={''}
      >
        <div className={'container'}>
          <div className={'row'}>
            <div className={'col-12 col-lg-3'}>
              <WPBaseLink
                href={'/'}
                title={'Navigate home'}
                className={'c-footer-primary__bottom-logo'}
                onClick={() => {
                  analytics.navigationClickEvent({
                    navigationType: 'footer',
                    clickText: 'Navigate home',
                    linkType: 'link',
                  });
                }}
              >
                <img
                  src={`${BASE_URL}/img/logo-rev.png`}
                  alt={'White Plains Hospital - Home'}
                />
              </WPBaseLink>
            </div>
            <div className={'col-12 col-lg-6'}>
              <ul className={'c-footer-primary__bottom-links'}>
                <li>
                  <WPBaseLink
                    href={'/sitemap/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Site map',
                        linkType: 'link',
                      });
                    }}
                  >
                    Site map
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/compliancehipaa/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Compliance/HIPAA',
                        linkType: 'link',
                      });
                    }}
                  >
                    Compliance/HIPAA
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/accessibility/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Accessibility',
                        linkType: 'link',
                      });
                    }}
                  >
                    Accessibility
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/medical-dental-staff-portal/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Medical & dental staff portal',
                        linkType: 'link',
                      });
                    }}
                  >
                    Medical &amp; dental staff portal
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/nurses-portal/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: "Nurses' portal",
                        linkType: 'link',
                      });
                    }}
                  >
                    Nurses&apos; portal
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/employee-resources/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Employee resources',
                        linkType: 'link',
                      });
                    }}
                  >
                    Employee resources
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/careers/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Careers',
                        linkType: 'link',
                      });
                    }}
                  >
                    Careers
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={'/patients-visitors/patients/patient-relations/'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Patient Relations Department',
                        linkType: 'link',
                      });
                    }}
                  >
                    Patient Relations Department
                  </WPBaseLink>
                </li>
                <li>
                  <WPBaseLink
                    href={
                      '/patients-visitors/patients/billing-information/standard-charges/'
                    }
                    target={'_blank'}
                    rel={'noopener noreferrer'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Price transparency',
                        linkType: 'link',
                      });
                    }}
                  >
                    Price transparency
                  </WPBaseLink>
                </li>
              </ul>
            </div>
            <div className={'col-12 col-lg-3'}>
              <a
                href={'tel:+19146810600'}
                aria-label={t('aria.callLocation', {
                  locationName: 'White Plains Hospital',
                })}
                className={'c-footer-primary__bottom-tel'}
                onClick={() => {
                  analytics.navigationClickEvent({
                    navigationType: 'footer',
                    clickText: '914.681.0600',
                    linkType: 'link',
                  });
                  analytics.calledEvent({
                    linkContextPage: 'Home',
                    clickURL: 'tel:+19146810600',
                    clickText: '914.681.0600',
                  });
                }}
              >
                914.681.0600
              </a>
              <ul className={'c-footer-primary__bottom-social'}>
                <li>
                  <a
                    href={
                      'https://www.facebook.com/WPHospital?ref=ts%3Fref%3Dts'
                    }
                    target={'_blank'}
                    aria-label={'Like us on Facebook, opens in new tab'}
                    rel={'noopener noreferrer'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Like us on Facebook',
                        linkType: 'link',
                      });
                    }}
                  >
                    <Facebook
                      aria-hidden={'true'}
                      style={{
                        height: 36,
                        width: 36,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href={'https://twitter.com/WPHospital'}
                    target={'_blank'}
                    aria-label={'Follow us on X, opens in new tab'}
                    rel={'noopener noreferrer'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Follow us on X',
                        linkType: 'link',
                      });
                    }}
                  >
                    <Twitter
                      aria-hidden={'true'}
                      style={{
                        height: 36,
                        width: 36,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href={'https://www.instagram.com/wphospital/'}
                    target={'_blank'}
                    aria-label={'Follow us on Instagram, opens in new tab'}
                    rel={'noopener noreferrer'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Follow us on Instagram',
                        linkType: 'link',
                      });
                    }}
                  >
                    <Instagram
                      aria-hidden={'true'}
                      style={{
                        height: 36,
                        width: 36,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href={
                      'https://www.linkedin.com/company/whiteplainshospital/'
                    }
                    target={'_blank'}
                    aria-label={'Find us on LinkedIn, opens in new tab'}
                    rel={'noopener noreferrer'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Find us on LinkedIn',
                        linkType: 'link',
                      });
                    }}
                  >
                    <WPLinkedIn
                      aria-hidden={'true'}
                      style={{
                        height: 36,
                        width: 36,
                      }}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href={'https://www.pinterest.com/WhitePlainsHospital/'}
                    target={'_blank'}
                    aria-label={'Follow us on Pinterest, opens in new tab'}
                    rel={'noopener noreferrer'}
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'footer',
                        clickText: 'Follow us on Pinterest',
                        linkType: 'link',
                      });
                    }}
                  >
                    <WPPinterest
                      aria-hidden={'true'}
                      style={{
                        height: 36,
                        width: 36,
                      }}
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-12'}>
              <p className={'copyright'}>© {year} White Plains Hospital</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
